import React from 'react';
import { CardProducElement, CardProductDetail, CardProductImage, CardProductPriceCta } from './CardProduct.styles';
import { Text, Title } from '@/components/typography';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import TravelDetailList from '@/features/pacote/components/TravelDetailList/TravelDetailList';
import CardMedia from '@/components/card/CardMedia/CardMedia';
import TagsBadgeList from '@/features/pacote/components/TagsBadgeList/TagsBadgeList';
import { useTranslations } from 'next-intl';

export interface CardProductProps {
  prefix?: string;
  pacote: PacoteItineraryType;
  className?: string;
}

const CardProduct = ({ prefix, pacote }: CardProductProps) => {
  const t = useTranslations('Pacote');
  const {
    uuid,
    title,
    permalink,
    media,
    travel_type,
    travel_cities,
    travel_amount,
    travel_currency,
    travel_flight,
    travel_amount_info,
    travel_duration,
    travel_departure,
    travel_meal,
    expired_at,
    reference,
    tags,
  } = pacote;

  return (
    <CardProducElement>
      <CardProductImage>
        <CardMedia
          media={media}
          href={permalink}
          minHeight={256}
          minHeightMobile={256}
          // mediaOptions={{ featured: true }}
          mediaOptions={{ transform: { width: 600, height: 256 * 2, gravity: 'west', crop: 'fill' } }}
        />
        <TagsBadgeList tags={tags} position="absolute" />
      </CardProductImage>
      <CardProductDetail>
        <Link href={permalink}>
          <Title as="h2" size="lg">
            {prefix} {title}
          </Title>
        </Link>
        <TravelDetailList {...pacote} />
      </CardProductDetail>
      <CardProductPriceCta>
        <Text as="span" textCase="uppercase" weight="light">
          {(travel_amount !== 0 && t('preço a partir')) || ''}
        </Text>
        <div>
          <Text as="span" size="xl" weight="bold">
            {(!travel_amount && (
              <Text as="small" size="md">
                {t('Consulte-nos')}
              </Text>
            )) || (
              <>
                <Text as="small" size="md">
                  {travel_currency}
                </Text>{' '}
                {travel_amount}
                {(travel_currency !== 'BRL' && <sup>*</sup>) || null}
              </>
            )}
          </Text>
          {(travel_amount && (
            <Text size="xs" as="small" textCase="uppercase">
              {travel_amount_info}
            </Text>
          )) ||
            null}
        </div>
        <Button href={permalink} block arrow appearance="outline">
          {t('VEJA O ROTEIRO')}
        </Button>
      </CardProductPriceCta>
    </CardProducElement>
  );
};

export default CardProduct;
